// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__wY1T_","amount":"Amount_amount__zv-er","tip":"Amount_tip__1Zjah","tipHeader":"Amount_tipHeader__3VKBQ","tipsWrap":"Amount_tipsWrap__1ZHIE"};